import { render, staticRenderFns } from "./AracUzerindekiYakalamaSerhininKaldirilmasiTalepEvrakForm.vue?vue&type=template&id=600fa4a6"
import script from "./AracUzerindekiYakalamaSerhininKaldirilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./AracUzerindekiYakalamaSerhininKaldirilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports